import { render, staticRenderFns } from "./DocFaceSearch.vue?vue&type=template&id=2783bdbe&scoped=true"
import script from "./DocFaceSearch.vue?vue&type=script&lang=js"
export * from "./DocFaceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2783bdbe",
  null
  
)

export default component.exports